// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BsTelephoneFill } from 'react-icons/bs';

// Import du CSS global
import './App.css';

// Import des Pages
import Home from './pages/Home';

// Import du Header
import Header from './components/Header';

function App() {
  return (
    <Router>
      <Header /> 
      
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>

      {/* Bouton d'appel rapide flottant pour mobile */}
      <a href="tel:+262692142803" className="floating-call-btn" title="Appeler TechniServices">
        <BsTelephoneFill />
        <span>06 92 14 28 03</span>
      </a>
    </Router>
  );
}

export default App;